import { __assign } from "tslib";
import React from 'react';
import xss, { friendlyAttrValue, safeAttrValue as XssSafeAttrValue, } from 'xss';
function safeAttrValue(tag, name, value, cssFilter) {
    if (name === 'href') {
        var friendlyValue = friendlyAttrValue(value);
        if (friendlyValue.startsWith('${') && friendlyValue.indexOf('}') !== -1) {
            return value;
        }
    }
    return XssSafeAttrValue(tag, name, value, cssFilter);
}
export var SecureHtml = React.memo(function (_a) {
    var html = _a.html, containerProps = _a.containerProps, _b = _a.as, Component = _b === void 0 ? 'div' : _b, skipCleaning = _a.skipCleaning;
    var cleanHtml;
    if (skipCleaning) {
        cleanHtml = html;
    }
    else {
        cleanHtml = xss(html, {
            allowList: {
                h1: ['style', 'dir', 'class'],
                h2: ['style', 'dir', 'class'],
                h3: ['style', 'dir', 'class'],
                div: ['style', 'dir', 'class'],
                span: ['style', 'dir', 'class'],
                p: ['style', 'dir', 'class'],
                a: ['style', 'dir', 'target', 'rel', 'href'],
                ol: ['style', 'dir', 'class', 'start'],
                ul: ['style', 'dir', 'class'],
                li: ['style', 'dir', 'class'],
                comment: [],
                s: [],
                b: [],
                i: [],
                u: [],
                bdi: ['style', 'dir'],
                br: [],
                pre: [],
            },
            css: false,
            safeAttrValue: safeAttrValue,
        });
    }
    return (React.createElement(Component, __assign({}, containerProps, { dangerouslySetInnerHTML: { __html: cleanHtml } })));
});
//# sourceMappingURL=SecureHtml.js.map